import { render, staticRenderFns } from "./message.vue?vue&type=template&id=4d731930&scoped=true&"
import script from "./message.vue?vue&type=script&lang=js&"
export * from "./message.vue?vue&type=script&lang=js&"
import style0 from "./message.vue?vue&type=style&index=0&id=4d731930&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d731930",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTimelineItem } from 'vuetify/lib/components/VTimeline';
installComponents(component, {VCard,VIcon,VTimelineItem})
